module.exports = __webpack_public_path__ + "img/angle-right.1b91707d.svg";